import { AxiosRequestConfig } from 'axios';

import {
  PostTailorRequestPayload,
  RespondTailoringRequestPayload,
  TailoringRequest,
} from '@/features/tailoring-requests/types';
import { apiClient } from '@/lib/api/client';

export const postListingTailorRequest = async (
  data: PostTailorRequestPayload,
  options?: AxiosRequestConfig,
) => {
  return apiClient<TailoringRequest>(
    {
      method: 'POST',
      url: `/tailoring-requests`,
      data,
    },
    options,
  );
};

export const getUserTailoringRequests = async (config?: AxiosRequestConfig) => {
  return apiClient<TailoringRequest[]>(
    {
      method: 'GET',
      url: `/tailoring-requests`,
    },
    config,
  );
};

export const getStoreTailoringRequests = async (
  config?: AxiosRequestConfig,
) => {
  return apiClient<TailoringRequest[]>(
    {
      method: 'GET',
      url: `/tailoring-requests/store`,
    },
    config,
  );
};

export const respondToTailoringRequest = async (
  { requestId, status }: RespondTailoringRequestPayload,
  config?: AxiosRequestConfig,
) => {
  return apiClient(
    {
      method: 'PATCH',
      url: `/tailoring-requests/${requestId}`,
      data: { status },
    },
    config,
  );
};
